import Cookie from 'js-cookie'
import { type FC, useEffect, useState } from 'react'

import { USER_ACCESS_TOKEN } from '@/constants/shopify'
import { $customer, type Customer } from '@/stores/account/stores'
import { $cart } from '@/stores/cart/stores'
import type { Cart } from '@/types/shopify'
import { useStore } from '@nanostores/react'

import { loadSubscriptionsForRewards } from '@/stores/account/operations'
import { RewardsWidget } from './RewardsWidget'

interface RewardsProps {
  scriptUrl: string
  scriptCode: string
  redemptionOptionId?: number
}

export const Rewards: FC<RewardsProps> = ({
  scriptCode,
  scriptUrl,
  redemptionOptionId,
}) => {
  const [token, setToken] = useState<string>()
  const [hasFreeProduct, setHasFreeProduct] = useState<boolean>(false)
  const [hasPaidProduct, setHasPaidProduct] = useState<boolean>(false)
  const [cartPoints, setCartPoints] = useState<number>(0)

  const customer = useStore($customer)
  const cart = useStore($cart)

  const checkForProductDetails = (cart: Cart | null) => {
    const freeProducts = cart?.lines.filter(
      (item) =>
        item.attributes?.find(
          (attr) => attr.key === 'swell_redemption_id' || attr.key === '_gift',
        ),
    )

    const giftProducts = cart?.lines.filter(
      (item) =>
        item.attributes?.find((attr) => attr.key === '_swell_redemption_id'),
    )

    const hasFreeProduct = !!giftProducts?.length
    const hasPaidProduct = cart?.lines.length !== freeProducts?.length
    const points = cart?.lines.reduce((total, item) => {
      const pointAttribute = item.attributes.find(
        (attr) => attr.key === '_swell-points-used' && attr.value === 'true',
      )
      return pointAttribute ? total + item.quantity : total
    }, 0)
    setHasFreeProduct(hasFreeProduct)
    setHasPaidProduct(hasPaidProduct)
    setCartPoints(points || 0)

    return { hasPaidProduct, hasFreeProduct }
  }

  const getToken = async (customer: Customer | null) => {
    const accessToken = Cookie.get(USER_ACCESS_TOKEN)
    if (accessToken && customer) {
      // await initialLoadCustomer(accessToken)

      const response = await fetch('/api/generate-sha-yotpo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: customer.email }),
      })
      const data = await response.json()

      setToken(data.hash)
    }
  }

  useEffect(() => {
    getToken(customer)
  }, [customer])

  useEffect(() => {
    checkForProductDetails(cart)
  }, [cart])

  useEffect(() => {
    loadSubscriptionsForRewards()
  }, [])

  return (
    <div>
      <RewardsWidget
        customer={customer}
        token={token}
        hasFreeProduct={hasFreeProduct}
        hasPaidProduct={hasPaidProduct}
        cart={cart}
        checkForProductDetails={checkForProductDetails}
        cartPoints={cartPoints}
        scriptUrl={scriptUrl}
        scriptCode={scriptCode}
        redemptionOptionId={redemptionOptionId}
      />
    </div>
  )
}
